export const SIZE_CLASSES_TAG = Object.freeze({
  small: 'px-2 py-0.5 text-xs',
  medium: 'px-3 py-1 text-sm',
  large: 'h-8 px-3 text-sm',
  xlarge: 'h-12 px-4 text-xl',
});

export const SIZE_CLASSES_CIRCLE = Object.freeze({
  small: 'h-6 w-6 text-xs',
  medium: 'h-7 w-7 text-sm',
  large: 'h-8 w-8 text-sm',
  xlarge: 'h-10 w-10 text-base',
  '2xlarge': 'h-12 w-12 text-xl',
});
